import Image from '@next/image';
import classNames from 'classnames';

import ImageFile from 'types/ImageFile';
import { ManufacturerPartnership as ManufacturerPartnershipType } from 'types/models/ManufacturerPartnership';
import Typography from '@components/atoms/Typography';
import ManufacturerPartnership from '@templates/ManufacturerPartnership';

import classes from './CategoryLevelHeader.module.scss';

type Props = {
  name: string;
  header?: string;
  iconFile?: ImageFile;
  partnership?: ManufacturerPartnershipType;
  className?: string;
};

const CategoryLevelHeader = ({ name, header, iconFile, partnership, className }: Props) => (
  <div className={classNames(classes.header, className)}>
    <div className={classes.headerContent}>
      {iconFile && (
        <Image
          objectFit="contain"
          alt={name}
          resolveConfig={{
            preset: 'i',
            extension: iconFile?.extension,
            name: iconFile?.basename,
            productName: `icon-${name}`,
          }}
          width={52}
          height={52}
          hasLazyLoad={false}
          hasPreload
        />
      )}
      <Typography variant="h1" className={classes.headerText}>
        {header || name}
      </Typography>
    </div>
    {partnership && <ManufacturerPartnership partnership={partnership} />}
  </div>
);

export default CategoryLevelHeader;
